import { Console } from '@angular/core/src/console';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CellClickedEvent, GridApi, GridOptions } from 'ag-grid-community';
import { GLOBAL } from 'src/app/app.globals';
import { AgActionCellRendererComponent, AgNumberCountComponent } from 'src/app/core/components';
import { AgActionCellLockRendererComponent } from 'src/app/core/components/grid-wrapper/helper/ag-action-cell-lock-renderer/ag-action-cell-lock-renderer.component';
import { AgActionCellPermissionRendererComponent } from 'src/app/core/components/grid-wrapper/helper/ag-action-cell-permission-renderer/ag-action-cell-permission-renderer.component';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { DynamicApicallService } from 'src/app/service/dynamic-apicall.service';
import { RefreshUserViewModalComponent } from '../refresh-user-view-modal/refresh-user-view-modal.component';

@Component({
  selector: 'app-refresh-user-modal',
  templateUrl: './refresh-user-modal.component.html',
  styleUrls: ['./refresh-user-modal.component.css']
})
export class RefreshUserModalComponent implements OnInit {

  @Input() responseData: any; 
  private reportValueData: any[] = [];
  errorMessage : any;
  
  gridAPI: GridApi;
  gridOptions: GridOptions = {
    animateRows: true,
    rowSelection: 'multiple',
    rowHeight: 40,
    headerHeight: 40,
    pagination: true,
    context: {
      componentParent: this 
    }
  };

  constructor(
    public activeModal: NgbActiveModal,
    private logHelperService: LogHelperService,
    private modalService: NgbModal,
    private apiCall: DynamicApicallService,
  ) { }
  
  ngOnInit() {
    this.errorMessage = this.responseData.Table1[0].Message
    this.rowData = this.responseData.Table2
  }

  columnDefs = [
    {
      headerName: "#",
      field: "sortCode",
      width: 50,
      sortable: false,
      suppressMenu: true,
      cellRendererFramework: AgNumberCountComponent,
    },
    {
      headerName: "First Name",
      field: "FirstName",
      width: 150,
      sortable: true,
      filter: true,
      filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: " User Code",
      field: "UserCode",
      width: 150,
      sortable: true,
      filter: true,
      filterParams: { applyButton: true, clearButton: true },
      tooltip: (params) => "Copy User Code",
      cellRenderer: function (params) {
        return (
          '<span class="hover-shadow">' +
          params.value +
          '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
          params.value +
          "></i> </span>"
        );
      },
      onCellClicked: (event: CellClickedEvent) => {
        const cellValue = event.value;
        if (navigator && navigator["clipboard"]) {
          navigator["clipboard"].writeText(cellValue).then(() => {
            console.log("Text copied to clipboard:", cellValue);
          });
        }
      },
    },
    {
      headerName: "User Name",
      field: "UserName",
      width: 150,
      sortable: true,
      filter: true,
      tooltip: (params) => "Copy User Name",
      filterParams: { applyButton: true, clearButton: true },
      cellRenderer: function (params) {
        return (
          '<span class="hover-shadow">' +
          params.value +
          '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
          params.value +
          "></i> </span>"
        );
      },
      onCellClicked: (event: CellClickedEvent) => {
        const cellValue = event.value;
        if (navigator && navigator["clipboard"]) {
          navigator["clipboard"].writeText(cellValue).then(() => {
            console.log("Text copied to clipboard:", cellValue);
          });
        }
      },
    },
    {
      headerName: "Email ",
      field: "AlternetEmailID",
      width: 150,
      sortable: true,
      filter: true,
      filterParams: { applyButton: true, clearButton: true },
      tooltip: (params) => "Copy Email",
      cellRenderer: function (params) {
        return (
          '<span class="hover-shadow">' +
          params.value +
          '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
          params.value +
          "></i> </span>"
        );
      },
      onCellClicked: (event: CellClickedEvent) => {
        const cellValue = event.value;
        if (navigator && navigator["clipboard"]) {
          navigator["clipboard"].writeText(cellValue).then(() => {
            console.log("Text copied to clipboard:", cellValue);
          });
        }
      },
    },
    {
      headerName: "Mobile No",
      field: "MobileNo",
      width: 150,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {
        return (
          '<span class="hover-shadow">' +
          params.value +
          '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' +
          params.value +
          "></i> </span>"
        );
      },
      tooltip: (params) => "Copy Mobile No",
      filterParams: { applyButton: true, clearButton: true },
      onCellClicked: (event: CellClickedEvent) => {
        const cellValue = event.value;
        if (navigator && navigator["clipboard"]) {
          navigator["clipboard"].writeText(cellValue).then(() => {
            console.log("Text copied to clipboard:", cellValue);
          });
        }
      },
    },
    // {
    //   headerName: 'Is Organization User', field: 'IsOrganizationUser', width: 50, sortable: true, filter: true,
    //   filterParams: { applyButton: true, clearButton: true }
    // },
    {
      headerName: "Status",
      field: "",
      width: 150,
      sortable: false,
      suppressMenu: true,
      cellRendererFramework: AgActionCellLockRendererComponent,
    },
    // {
    //   headerName: 'Reset Password', field: '', width: 50,
    //   sortable: false, suppressMenu: true, cellRendererFramework: AgActionCellActiveRendererComponent
    // },
    // {
    //   headerName: "Access and Permission",
    //   field: "",
    //   width: 50,
    //   sortable: false,
    //   suppressMenu: true,
    //   cellRendererFramework: AgActionCellPermissionRendererComponent,
    //   cellRendererParams: (params: any) => ({
    //     isRefresh: true,
    //     isAppPermission: true
    //   }),
    // },
    // {
    //   headerName: 'Is Active', field: '', width: 25,
    //   sortable: false, suppressMenu: true, cellRendererFramework: AgActionCellActiveRendererComponent
    // },
    {
      headerName: "Action",
      field: "",
      width: 150,
      hide: [115, 116, 117].includes(GLOBAL.ROLE_CODE),
      sortable: false,
      suppressMenu: true,
      cellRendererFramework: AgActionCellRendererComponent,
      cellRendererParams: {
        isPasswordReset: false,
        isEdit: false,
        isDeleteRecord: true,
        isView: true, 
      },
    },
  ];
  rowData: any;
  

  onView(data) {
    const reqObj = {
      Filter: {
          "UserID": Number(data.UserID),
          "RequireType": 0,
          "Action":0,
          "RequestedUserID": Number(GLOBAL.USER_ID)
      },
    };
    this.apiCall
        .callApi("Common/MultiTableList/COMMON_USER_Datacheck", "POST", {
          body: reqObj,
        })
        .subscribe((res) => {
          if (res) {
            const modalRef = this.modalService.open(RefreshUserViewModalComponent, {
              size: "lg",
              backdrop: "static",
              windowClass: "modal-panel",
            });
      
            // Pass data to the modal component if needed
            modalRef.componentInstance.responseData = res;
          } else {
            this.logHelperService.logError({
              message: `${data.Company} not updated`,
            });
          }
        });
  }

  onDeleteRecord(data) {
    const reqObj = {
      Filter: {
          "UserID": Number(data.UserID),
          "RequireType": 1,
          "Action":1,
          "RequestedUserID": Number(GLOBAL.USER_ID)
      },
    };
    this.apiCall
        .callApi("Common/MultiTableList/COMMON_USER_Datacheck", "POST", {
          body: reqObj,
        })
        .subscribe((res) => {
          res
            ? this.logHelperService.logSuccess({
                message: `${data.Company} refresh successfully`,
              })
            : this.logHelperService.logError({
                message: `${data.Company} not updated`,
              });
        });
    console.log(data)
  }

  onCloseAction() {
    this.activeModal.close(); 
  }
}
